import { Fancybox } from '@fancyapps/ui'; // eslint-disable-line

export default ($) => {

	function loadVioletteCollection(termsVal, typeVal, volVal, yearVal, pageVal) {
		$.ajax({
			type : 'post',
			dataType : 'html',
			url : '/wp-admin/admin-ajax.php',
			//url : obj_data.ajaxurl,
			data : {
				action : 'load_violette_collection',
				terms : termsVal,
				type : typeVal,
				volume : volVal,
				year : yearVal,
				page : pageVal
			},
			success : function(rd) {
				$('#results-container-' + pageVal).html(rd);
				violetteSearchListeners(false);
				let violetteResultsContainer = document.getElementsByClassName('js-violette-cards');
				if (typeof violetteResultsContainer[0] !== 'undefined' && violetteResultsContainer[0] !== null) {
					violetteResultsContainer[0].setAttribute('data-page', pageVal);
					violetteResultsContainer[0].setAttribute('data-type', typeVal);
					violetteResultsContainer[0].setAttribute('data-terms', termsVal);
					violetteResultsContainer[0].setAttribute('data-volume', volVal);
					violetteResultsContainer[0].setAttribute('data-year', yearVal);
				}
			},
			error : function(MLHttpRequest, rd, errorMsg) {
				console.log(errorMsg);
			}
		});
	}

	function updateVioletteSearch(page) {
		const newResContainer = document.createElement('div');
		let violetteCollectionContainer = document.getElementById('violette-collection-container');
		newResContainer.id = 'results-container-' + page;
		newResContainer.classList = 'results-container';
		violetteCollectionContainer.appendChild(newResContainer);

		let terms = document.getElementById('violette-search-field').value;
		let type = document.getElementById('violette-itype').value;
		let volume = document.getElementById('violette-volume').value;
		let year = document.getElementById('violette-year').value;

		loadVioletteCollection(terms, type, volume, year, page);
	}

	function violetteSearchListeners(init) {

		let searchField = document.getElementById('violette-search-field');

		if (typeof searchField !== 'undefined' && searchField !== null) {
			if (init) {
				loadVioletteCollection('', '', '', '', 1);
			}
			let typeField = document.getElementById('violette-itype');
			console.log(typeField);
			let volumeField = document.getElementById('violette-volume');
			let yearField = document.getElementById('violette-year');
			let loadMore = document.getElementsByClassName('js-load-collection-items');
			let submitBtn = document.getElementById('submit-search');
			let resultsContainer = document.getElementsByClassName('js-violette-cards');

			searchField.addEventListener('keydown', function(e){
				if (e.keyCode === 13) {
					let terms = searchField.value;
					let type = typeField.value;
					let volume = volumeField.value;
					let year = yearField.value;
					let violetteCollectionContainer = document.getElementById('violette-collection-container');
					let resContainers = document.getElementsByClassName('results-container');

					for (let rc=1; rc<resContainers.length; rc++) {
						violetteCollectionContainer.removeChild(resContainers[rc]);
					}
					updateVioletteSearch(1);
				}
			});

			submitBtn.addEventListener('click', function(e){
				e.preventDefault();
				let terms = searchField.value;
				let type = typeField.value;
				let volume = volumeField.value;
				let year = yearField.value;
				let violetteCollectionContainer = document.getElementById('violette-collection-container');
				let resContainers = document.getElementsByClassName('results-container');

				for (let rc=1; rc<resContainers.length; rc++) {
					violetteCollectionContainer.removeChild(resContainers[rc]);
				}
				updateVioletteSearch(1);
			});

			submitBtn.addEventListener('keydown', function(e){
				e.preventDefault();
				if (e.keyCode === 13) {
					let terms = searchField.value;
					let type = typeField.value;
					let volume = volumeField.value;
					let year = yearField.value;
					let page = parseInt(resultsContainer[0].getAttribute('data-page')) + 1;
					document.getElementById('results-next').remove();
					updateVioletteSearch(page);
				}
			});

			for (let lm=0; lm < loadMore.length; lm++) {
				loadMore[lm].addEventListener('click', function(e){
					e.preventDefault();
					let terms = searchField.value;
					let type = typeField.value;
					let volume = volumeField.value;
					let year = yearField.value;
					let page = parseInt(resultsContainer[0].getAttribute('data-page')) + 1;
					document.getElementById('results-next').remove();
					updateVioletteSearch(page);
				});

				loadMore[lm].addEventListener('keydown', function(e){
					e.preventDefault();
					if (e.keyCode === 13) {
						let terms = searchField.value;
						let type = typeField.value;
						let volume = volumeField.value;
						let year = yearField.value;
						let page = parseInt(resultsContainer[0].getAttribute('data-page')) + 1;
						document.getElementById('results-next').remove();
						updateVioletteSearch(page);
					}
				});
			}
		}
	}

	jQuery(document).ready(function(){
		violetteSearchListeners(true);
	});
};